import {
    Instagram,
    Youtube,
    Music2,
    Linkedin,
    Facebook,
} from "lucide-react";
import { socials } from "../../lib/socials";
import { IconX, IconTelegram, IconWhatsApp, IconViber } from "./BrandIcons";

const items = [
    { key: "whatsapp", href: socials.whatsapp, Icon: IconWhatsApp, label: "WhatsApp" },
    { key: "instagram", href: socials.instagram, Icon: Instagram, label: "Instagram" },
    { key: "youtube", href: socials.youtube, Icon: Youtube, label: "YouTube" },
    { key: "tiktok", href: socials.tiktok, Icon: Music2, label: "TikTok" },
    { key: "facebook", href: socials.facebook, Icon: Facebook, label: "Facebook" },
    { key: "linkedin", href: socials.linkedin, Icon: Linkedin, label: "LinkedIn" },
    { key: "x", href: socials.x, Icon: IconX, label: "X" },
    { key: "telegram", href: socials.telegram, Icon: IconTelegram, label: "Telegram" },
    { key: "viber", href: socials.viber, Icon: IconViber, label: "Viber" },
];

export default function SocialIcons({ size = "sm", testidPrefix = "social" }) {
    const isLg = size === "lg";
    return (
        <div className={`flex flex-wrap items-center ${isLg ? "gap-3" : "gap-2"}`}>
            {items.map((it) => {
                const Icon = it.Icon;
                return (
                    <a
                        key={it.key}
                        href={it.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={it.label}
                        title={it.label}
                        data-testid={`${testidPrefix}-${it.key}`}
                        className={`${isLg ? "w-10 h-10" : "w-8 h-8"} rounded-full flex items-center justify-center bg-white/[0.04] border border-white/10 text-white/75 hover:text-[#E55B13] hover:border-[#E55B13]/40 hover:bg-white/[0.08] transition-all duration-300`}
                    >
                        <Icon size={isLg ? 16 : 14} />
                    </a>
                );
            })}
        </div>
    );
}
